import { type FC } from 'react'

import type { MenuProps } from './types'
import { Button } from '../Button'
import clsx from 'clsx'

export const Menu: FC<MenuProps> = ({
  items,
  isOpen = false,
  className,
  testId = 'menu-items',
  trigger,
}) => {
  return (
    <div className="relative w-max">
      {typeof trigger !== 'undefined' && (
        <Button testId={`${testId}-trigger`} {...trigger} />
      )}
      <ul
        className={clsx(
          'flex flex-col rounded-lg border border-default w-max overflow-hidden drop-shadow-md py-2 bg-white justify-items-end absolute right-0 mt-2',
          {
            invisible: !isOpen,
          },
          className,
        )}
        data-testid={testId}
      >
        {items.map((buttonProps) => (
          <Button
            key={`menu-item-${buttonProps.label}`}
            size="md"
            {...buttonProps}
            className="rounded-none border-0 !w-full px-4"
            variant="subtle"
            align="left"
          />
        ))}
      </ul>
    </div>
  )
}
